import { render, staticRenderFns } from "./LearningGoalGradeShow.vue?vue&type=template&id=cf4f0bc4&"
import script from "./LearningGoalGradeShow.vue?vue&type=script&lang=js&"
export * from "./LearningGoalGradeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports